import PointerInteraction from 'ol/interaction/Pointer';
import MapBrowserEventType from 'ol/MapBrowserEventType';
import Event from 'ol/events/Event';

/**
 * @enum {string}
 */
export const IdentifyEventType = {
  /**
   * Triggered upon click on map
   * @event IdentifyEvent#identifycoord
   * @api
   */
  IDENTIFYCOORD: 'identifycoord',
};

/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Identify~Identify} instances are
 * instances of this type.
 */
export class IdentifyEvent extends Event {
  /**
   * @param {IdentifyEventType} type Type.
   * @param {Collection<import("../Feature").FeatureLike>} features
   * The features modified.
   * @param {import("../MapBrowserEvent.js").default} MapBrowserEvent
   * Associated {@link module:ol/MapBrowserEvent}.
   */
  constructor(type, coordinate, resolution, projection, params={}) {
    super(type);

    this.coordinate = coordinate;
    this.resolution = resolution;
    this.projection = projection;
    this.params = params;
  }
}

/**
 * @constructor
 * @extends {ol.interaction.Pointer}
 */
class Identify extends PointerInteraction {
  /**
   * @param {Options} [opt_options] Options.
   */
  constructor(opt_options) {
    const options = opt_options ? opt_options : {};
    super(options);

    this._event = options?.event ?? IdentifyEventType.IDENTIFYCOORD;
    this._title = options.title || 'Info' ;
    this._infoOutsideAddFeature = options.infoOutsideAddFeature || 'Coordinate out of bounds' ;
    // this.setActive(false);
  }

  /**
   * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */
  handleEvent(mapBrowserEvent) {
    const map = mapBrowserEvent.map;
    const view = map.getView();
    const pixel = mapBrowserEvent.pixel;
    const hit = map.hasFeatureAtPixel(pixel);

    if (mapBrowserEvent.type == MapBrowserEventType.POINTERMOVE) {
      if (mapBrowserEvent.dragging) {
          return true;
      }

      // var target = map.getTargetElement();
      // let viewport = target.querySelector('.ol-viewport');
      // let classes = viewport ? viewport.classList : null;
      // if(classes){
      //     if(hit){
      //         classes.remove('cursor-pointer');
      //     }else{
      //         classes.add('cursor-pointer');
      //     }
      // }
      this.setCursor(!hit);
      return true;
    }

    if (mapBrowserEvent.type != MapBrowserEventType.CLICK) {
      return true;
    }

    if(hit){
      // isto poderá ser melhorado em relação aos pontos e linhas....
      let feats = map.getFeaturesAtPixel(pixel);
      let onlyPolygons = feats.filter(f => ['polygon','circle','multipolygon'].includes(f.getGeometry().getType().toLowerCase())).length == feats.length;
      if(!onlyPolygons){
        return true;
      }
    }

    let coordinate = mapBrowserEvent.coordinate;
    let resolution = view.getResolution();
    let projection = view.getProjection().getCode();
    let params = {};

    this.dispatchEvent(
      new IdentifyEvent(
        this._event,
        coordinate,
        resolution,
        projection,
        params
      )
    );

    // The function may return false to prevent the propagation of the event to other
    return false;

  }

  setCursor(flag) {
    const map = this.map_;
    if(map){
      let target = map.getTargetElement();
      if(target){
        let viewport = target.querySelector('.ol-viewport');
        let classes = viewport ? viewport.classList : null;
        if(classes){
          if(flag){
            classes.add('cursor-pointer');
          }else{
            classes.remove('cursor-pointer');
          }
        }
      }
    }
  }

  /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */
  setActive(active) {
    this.setCursor(false);
    super.setActive(active);
  }

};

export default Identify;